import { SplitSlider } from "../../../components/split-slider";
import { TEST_TYPES } from "../../../../constants";

export interface SliderWrapperProps {
  item: {
    values: string;
    [key: string]: string;
  };
  value?: number;
  onChange: (e: { target: { value: number } }) => void;
}
export function SliderWrapper({ item, onChange, value }: SliderWrapperProps) {
  const mode = item.type === TEST_TYPES.SingleSlider ? "standard" : "split";

  function handleValueChange(value: number) {
    onChange({ target: { value: value / 100 } });
  }

  return (
    <SplitSlider
      mode={mode}
      leftLabel={item.v1}
      rightLabel={item.v2}
      imageSrc={item.v3}
      rightImageSrc={item.v4}
      initialValue={typeof value === "number" ? value * 100 : 50}
      onValueChange={handleValueChange}
    />
  );
}
